/**
 * MetricDistributionRow component barrel export
 *
 * Exports the Container which handles press callback binding.
 */

export { default } from "./MetricDistributionRowContainer";
